import React, { Suspense, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { hasChangedSelector } from '../../services/ducks/workflowDuck/workflowDuck';
import { store } from '../../services/store/store';
import { lazyImport } from '../../utils';
import { SignIn } from '../pages';
import { ExitConfirmModal, callbackFn } from './ExitConfirmModal';

const { Designer } = lazyImport(() => import('../pages'), 'Designer');

const getUserConfirmation = (message: string, callback: callbackFn) => (
  <ExitConfirmModal message={message} callback={callback} />
);

export const App = () => {
  const { t: translate } = useTranslation();

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent): any => {
      const hasChanged = hasChangedSelector(store.getState());
      if (hasChanged) {
        event.preventDefault();
        const message = translate('exitconfirmmodal:message');
        event.returnValue = message;
        return message;
      } else {
        return '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Provider store={store}>
      <Router getUserConfirmation={getUserConfirmation}>
        <Suspense fallback={<div>Loading...</div>}>
          <Switch>
            <Route exact path="/designer/:workflowRef" component={Designer} />
            <Route exact path="/signin" component={SignIn} />
          </Switch>
        </Suspense>
      </Router>
    </Provider>
  );
};
